import { initContactForm } from '../contact/contact';
export {};

const CONFIG = {
  STORAGE_KEY: 'postIds',
};

function getStoredIds(): string[] {
  const raw = sessionStorage.getItem(CONFIG.STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function setStoredIds(ids: string[]): void {
  sessionStorage.setItem(CONFIG.STORAGE_KEY, JSON.stringify(ids));
}

function updateSelectionCount(): void {
  const countEl = document.getElementById('selected-count');
  if (countEl) {
    countEl.textContent = String(getStoredIds().length);
  }
}

function enforceMaxSelection(): void {
  const maxFiles = window.photoLibrary?.maxFiles ?? 5;
  const ids = getStoredIds();
  const checkboxes = document.querySelectorAll<HTMLInputElement>(
    'input[data-post-id]'
  );
  checkboxes.forEach((cb) => {
    if (!cb.checked) {
      cb.disabled = ids.length >= maxFiles;
    }
  });
}

function updateDownloadLink(): void {
  const link = document.getElementById(
    'download-request-link'
  ) as HTMLAnchorElement | null;
  if (!link) return;

  const count = getStoredIds().length;
  if (count === 0) {
    link.classList.add('opacity-50', 'pointer-events-none');
  } else {
    link.classList.remove('opacity-50', 'pointer-events-none');
  }
}

function initArchivePage(): void {
  const checkboxes = document.querySelectorAll<HTMLInputElement>(
    'input[data-post-id]'
  );
  if (checkboxes.length === 0) return;

  // sessionStorageから復元
  const storedIds = getStoredIds();
  checkboxes.forEach((cb) => {
    const postId = cb.getAttribute('data-post-id');
    if (postId && storedIds.includes(postId)) {
      cb.checked = true;
    }
  });

  updateSelectionCount();
  updateDownloadLink();
  enforceMaxSelection();

  // changeイベント
  checkboxes.forEach((cb) => {
    cb.addEventListener('change', () => {
      const postId = cb.getAttribute('data-post-id');
      if (!postId) return;

      let ids = getStoredIds();
      if (cb.checked) {
        if (!ids.includes(postId)) {
          ids.push(postId);
        }
      } else {
        ids = ids.filter((id) => id !== postId);
      }
      setStoredIds(ids);
      updateSelectionCount();
      updateDownloadLink();
      enforceMaxSelection();
    });
  });
}

declare global {
  interface Window {
    photoLibrary?: {
      maxFiles: number;
    };
    photoDownload?: {
      ajaxUrl: string;
      nonce: string;
    };
  }
}

function initPhotoRequestForm(): void {
  const form = document.getElementById('photo-request-form');
  if (!form) return;

  const storedIds = getStoredIds();
  if (storedIds.length === 0) {
    window.location.href = '/business/photo-library/';
    return;
  }

  initContactForm({
    formId: 'photo-request-form',
    completeUrl: '/business/photo-library-request/complete/',
    beforeSubmit: (formData) => {
      formData.append('selected-photo-ids', getStoredIds().join(','));
    },
  });
}

function initCompletePage(): void {
  const downloadBtn = document.getElementById(
    'download-zip-button'
  ) as HTMLButtonElement | null;
  if (!downloadBtn) return;

  const statusEl = document.getElementById('download-status');
  const ids = getStoredIds();

  if (ids.length === 0) {
    downloadBtn.disabled = true;
    downloadBtn.classList.add('opacity-50');
    if (statusEl) statusEl.textContent = 'ダウンロードする写真が選択されていません。';
    return;
  }

  downloadBtn.addEventListener('click', async () => {
    const config = window.photoDownload;
    if (!config) return;

    downloadBtn.disabled = true;
    downloadBtn.classList.add('opacity-50');
    if (statusEl) statusEl.textContent = 'ダウンロード準備中...';

    try {
      const params = new URLSearchParams();
      params.append('action', 'photo_download_zip');
      params.append('nonce', config.nonce);
      params.append('post_ids', ids.join(','));

      const res = await fetch(config.ajaxUrl, {
        method: 'POST',
        body: params,
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'photos.zip';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      sessionStorage.removeItem(CONFIG.STORAGE_KEY);
      if (statusEl) statusEl.textContent = 'ダウンロードが完了しました。';
    } catch {
      if (statusEl) statusEl.textContent = 'ダウンロードに失敗しました。時間をおいて再度お試しください。';
      downloadBtn.disabled = false;
      downloadBtn.classList.remove('opacity-50');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initArchivePage();
  initPhotoRequestForm();
  initCompletePage();
});
